import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取筛选可选荐列表（其中包含项目列表、需求提出人列表、项目品牌列表）
 * @param params
 */
export const getFiltersListApi = () => $http.get('/brand/keyInformation')

/**
 * 获取项目列表
 * @param params
 * type：1-获取全部（默认），2-根据条件获取
 */
export const getProjectListApi = (params: object) => $http.get('/brand/receiveWorkList', params)

/**
 * 获取项目/项目品牌详情
 * @param params
 *      id：项目ID，
 *      task_brand_id：项目品牌ID
 */
export const getProjectDetailApi = (id: any, task_brand_id: any = '') => $http.get('/brand/receiveWorkInfo', { id, task_brand_id })

/**
 * 保存项目备注
 * */ 
export const saveProjectRemarkApi = (id, remark) => $http.post('/brand/setRemark', { id, remark })

/**
 * 保存项目品牌状态（处理品牌状态、合作方式等）
 * @param data
 */
export const saveProjectBrandDetailApi = (data: object) => $http.post('/brand/treatmentState', data)

/**
 * 获取项目品牌列表
 * @param params
 */
export const getProjectBrandListApi = (params: object) => $http.get('/brand/receiveWorkBrand', params)

/**
 * 获取所有品牌列表（包含内部创建和宜搭项目创建审批通过后）
 * @param params
 */
export const getBrandListApi = (params: object) => $http.get('/brand/perfectionBrandList', params)

/**
 * 保存完善品牌信息
 * @param data
 */
export const saveBrandDetailApi = (data: object) => $http.post('/brand/insideBrandSave', data)

/**
 * 获取商家进度列表
 * @param params
 */
export const getProgressListApi = (params: object) => $http.get('/brand/followupList', params)

/**
 * 获取商家进度详情
 * @param params
 */
export const getProgressDetailApi = (task_brand_id: any) => $http.get('/brand/FollowupLogInfo', { task_brand_id })

/**
 * 保存完善品牌信息
 * @param data
 */
export const saveProgressDetailApi = (data: object) => $http.post('/brand/addFollowupLog', data)

/**
 * 修改跟进记录状态
 * @param data
 */
export const updateProgressStatusApi = (task_brand_id:number, type:number, content:object) => $http.post('/brand/transpond', { task_brand_id, type, content })

/**
 * 获取操作人列表
 * @param params
 */
export const getOperatorListApi = () => $http.get('/dsapi/trade/channel_sale_list')

/**
 * 跟进行记录加急
 * @param params
 */
export const updateProgressUrgencyApi = (task_brand_id:number) => $http.get('/brand/urgent', { task_brand_id })

/**
 * 跟进行记录强制终止
 * @param params
 */
export const cancelProgressApi = (task_brand_id:number) => $http.get('/brand/forcedTermination', { task_brand_id })